import httpClient from "../http-client/client";
export default class AgentService {
  //get agent user service
  getAgentUsers = () => {
    return httpClient.get("/user");
  };
  //get agent List service
  getAgentList = () => {
    return httpClient.get("/agent/list");
  };
  getBusinessName = () => {
    return httpClient.get("/agent/list_businessname");
  };
  getAgentInvoice = () => {
    return httpClient.get("/agent/list_invoice");
  };
  getInvoice = (id) => {
    return httpClient.get("/agent/get_invoice/",id);
  };
  UpdateStatus = payload => {
    return httpClient.put("/agent", payload);
  };
  //get agent
  // getAgent = () => {
  //   return httpClient.get("/agent/detail");
  // };
  
 // getAgent = () => {
 //   return httpClient.get(`/agent/detail?id=${4}`);
  //};
  
}